module.exports = __webpack_public_path__ + "img/t6-rse.50027062.svg";